import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'

import TabBar from './TabBar'
import ComponentsTab from './ComponentsTab'
import ScreensTab from './ScreensTab'

import './AddObject.css'

class AddPanel extends Component {
  shouldComponentUpdate(nextProps) {
    // eslint-disable-next-line react/destructuring-assignment
    return this.props.match.params.appId !== nextProps.match.params.appId
  }

  render() {
    const {
      match: {
        params: { appId },
      },
    } = this.props

    return (
      <TabBar
        initialActiveTab="component"
        tabs={[
          {
            id: 'component',
            title: 'ADD COMPONENT',
            component: ComponentsTab,
          },
          {
            id: 'screen',
            title: 'ADD SCREEN',
            component: ScreensTab,
          },
        ]}
        extraProps={{ appId }}
      />
    )
  }
}

export default withRouter(AddPanel)
